import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
export default class OtherContactService extends ApiService {
  namespace = "contact";
  template = "defaultTemplate";
  DOMAIN = 148;
  icon = "Contacts";
  name = "Other Contacts";
  singular = this.terminology.otherContact.singular;
  plural = this.terminology.otherContact.plural;
  vowel = this.terminology.otherContact.vowel;
  action = "action";
  Width = 1200;
  favicon = "YellowSilhouette";

  gemItems = [
    {
      key: "create",
      label: this.t("addAn") + " Other Contact",
      icon: PrimeIcons.PLUS_CIRCLE,
    },
    {
      key: "listing",
      label: this.t("all") + " Other Contacts",
      icon: PrimeIcons.LIST,
    },

    {
      key: "email",
      label: this.t("email") + " Other Contacts",
      icon: PrimeIcons.ENVELOPE,
    },
    {
      key: "report",
      label: this.t("generateReport"),
      icon: PrimeIcons.FILE_EXCEL,
    },
  ];

  columns = [
    {
      header: this.t("displayName"),
      icon: "UserSilhouette",
      field: "display_name",
    },

    {
      header: this.t("number"),
      icon: "Shred",
      field: "number",
    },

    {
      header: this.t("contact"),
      icon: "YellowSilhouette",
      field: "contact",
    },

    {
      header: this.t("phone"),
      icon: "MobilePhone",
      field: "phone",
    },
    {
      header: "Fax",
      icon: "FAX",
      field: "fax",
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: "Bullets",
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: "Bookmark",
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: 18,
      icon: "Disable",
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Open this Good...",
      icon: PrimeIcons.PENCIL,
    },
    {
      key: "announce",
      label: "announceThisEntity",
      services: -3,
      icon: PrimeIcons.LIST,
    },
    {
      key: "email",
      label: "emailThisEntity",
      icon: PrimeIcons.ENVELOPE,
    },
    {
      key: "bookmark",
      label: "bookmarkThisEntity",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: "inactiveThisEntity",
      icon: PrimeIcons.LOCK,
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding an Good",
      icon: PrimeIcons.LIST,
    },
  ];

  constructor() {
    super("other-contacts");
  }
}
